var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-progress-linear", {
        attrs: {
          color: "#128279",
          value: _vm.value,
          rounded: "",
          height: "8",
          "buffer-value": _vm.bufferValue
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }